import SuccessfulActionModalBody from "#/shared/components/modals/SuccessfulActionModalBody"
import { bigIntToHumanReadableFormat, floatToBigInt } from "#/shared/utils"
import { ComponentStepProps, useStepperModalContext } from "#/ui/Modal"

import { useManageStakeFlowContext } from "./ManageStakeFlowContext"

export default function StakeSuccessfullyUpdatedStep({
  onClickContinue,
}: ComponentStepProps) {
  const { manageType } = useManageStakeFlowContext()

  const {
    values: { amount: increasedAmount },
  } = useStepperModalContext<{
    amount: string
  }>()

  const title =
    manageType === "increase-amount"
      ? `${bigIntToHumanReadableFormat(floatToBigInt(increasedAmount))} BTC`
      : "Lock duration changed"

  const description =
    manageType === "increase-amount"
      ? "Congratulations on increasing staking amount! Your veBTC will be in your wallet soon."
      : undefined

  return (
    <SuccessfulActionModalBody
      title={title}
      description={description}
      onClickContinue={onClickContinue}
      nextStepButtonLabel="Done"
    />
  )
}
